import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1549.41826,299.604646 L1549.41826,1429.61963 L1753.33251,1225.58751 L1920,1392.25499 L1431.54876,1880.8241 L942.979643,1392.25499 L1109.64713,1225.58751 L1313.67925,1429.61963 L1313.67925,299.604646 L1549.41826,299.604646 Z M488.569113,160 L977.138227,648.569113 L810.470741,815.118729 L606.438622,611.204479 L606.438622,1741.10159 L370.699605,1741.10159 L370.699605,611.204479 L166.667485,815.118729 L-2.21689334e-12,648.569113 L488.569113,160 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconSortSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconSortSolid, _Component);

  var _super = _createSuper(IconSortSolid);

  function IconSortSolid() {
    _classCallCheck(this, IconSortSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconSortSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconSort",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconSortSolid.displayName = "IconSortSolid";
  return IconSortSolid;
}(Component);

IconSortSolid.glyphName = 'sort';
IconSortSolid.variant = 'Solid';
IconSortSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconSortSolid;
export { IconSortSolid };